import { GlButton } from '@gitlab/ui';
import BoldText from '~/vue_merge_request_widget/components/bold_text.vue';
import { I18N_SHA_MISMATCH } from '../../i18n';
import StateContainer from '../state_container.vue';
export default {
    name: 'ShaMismatch',
    components: {
        BoldText,
        GlButton,
        StateContainer
    },
    i18n: {
        I18N_SHA_MISMATCH
    },
    props: {
        mr: {
            type: Object,
            required: true
        }
    }
};
